module.exports = __webpack_public_path__ + "static/media/TrashWhite.5ec10215.svg";